const modifierCodes = (modifier: any): string[] => [...(modifier?.marking_codes ?? []), modifier?.marking_code].filter(Boolean);

export const collectMarkingCodes = (item: any): string[] => [
	...[item?.marking_code].filter(Boolean),
	...(item?.modifiers ?? []).flatMap(modifierCodes),
	...(item?.group_modifiers ?? []).flatMap((group: any) => (group?.modifiers ?? []).flatMap(modifierCodes)),
	...(item?.combos ?? []).flatMap((combo: any) => (combo?.groups ?? []).flatMap((group: any) => collectMarkingCodes(group?.item ?? group))),
];
